/* @jsx h */
import { computed, defineComponent, h } from "vue";
import { OrderItem, SuccesfullPartialPayment } from "@lemmonhq/types";
import { calculateOrderItemTotal, formatPrice } from "@lemmonhq/orders";
import { PaymentItem } from "./PaymentItem";
import { getItemPaymentStatus } from "./paymentUtils";
import { useAuth } from "@app/vue/providers/Auth";

interface PaymentGroupProps {
  items: OrderItem[];
  firstItem: OrderItem;
  totalQuantity: number;
  isExpanded: boolean;
  selectedItems: Record<number, number>;
  partialPayments: SuccesfullPartialPayment[];
  onSelect?: (itemId: number, quantity: number) => void;
  onToggle: () => void;
}

export const PaymentGroup = defineComponent<PaymentGroupProps>({
  name: "PaymentGroup",
  props: [
    "items",
    "firstItem",
    "totalQuantity",
    "isExpanded",
    "selectedItems",
    "partialPayments",
    "onSelect",
    "onToggle",
  ],
  setup(props) {
    const auth = useAuth();
    const paidQuantity = computed(() =>
      props.items.reduce(
        (state, item) =>
          state +
          getItemPaymentStatus(item, props.partialPayments).paidQuantity,
        0,
      ),
    );

    return () => (
      <div class="flex flex-col">
        {paidQuantity.value >= props.totalQuantity ? (
          <div class="flex justify-between items-center p-3 border  rounded opacity-50 cursor-pointer select-none">
            <div
              onClick={() => props.onToggle()}
              class="flex items-center gap-2 flex-1"
            >
              <div class=" flex">
                <span class="material-symbols-outlined ">
                  {props.isExpanded ? "keyboard_arrow_down" : "chevron_right"}
                </span>
              </div>
              <div class="flex flex-1">
                <span class="text-accent/80 cursor-pointer flex-1 pr-2">
                  {props.firstItem.product.name}
                </span>
                <span class=" ml-2 flex">
                  <div class="font-bold mr-2 text-success">PAID</div>{" "}
                  <span class="w-16 bg-neutral px-2 rounded text-center ">
                    {props.totalQuantity}
                  </span>
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div class="flex justify-between items-center p-3 border  rounded cursor-pointer select-none">
            <div
              onClick={() => props.onToggle()}
              class="flex items-center gap-2 flex-1 "
            >
              <div class="flex">
                <span class="material-symbols-outlined ">
                  {props.isExpanded ? "keyboard_arrow_down" : "chevron_right"}
                </span>
              </div>
              <div class="flex flex-1">
                <span class="text-accent/80 cursor-pointer flex-1 pr-2">
                  {props.firstItem.product.name}
                </span>
              </div>
              <div class="flex items-center gap-2 text-accent">
                <div class="text-accent/50">
                  {formatPrice(
                    calculateOrderItemTotal(
                      props.firstItem,
                      props.totalQuantity,
                    ),
                    true,
                    2,
                    auth.user.value?.restaurant.currency || "CHF",
                  )}
                </div>
                <span class="w-16 bg-neutral px-2 rounded text-center font-mono">
                  {props.totalQuantity}
                </span>
              </div>
            </div>
          </div>
        )}
        {props.isExpanded && (
          <div class="pl-4 space-y-2 mt-2">
            {props.items.map((item) => (
              <PaymentItem
                key={item.id}
                item={item}
                selectedQuantity={props.selectedItems[item.id] || 0}
                onSelect={props.onSelect}
                partialPayments={props.partialPayments}
              />
            ))}
          </div>
        )}
      </div>
    );
  },
});
